import React, { FC, PropsWithChildren } from 'react'

import { useRouteMatch } from 'react-router'
import styled from 'styled-components'

import { mambaLayoutContextId } from 'components/layout/MambaLayout/Context'
import { CreateBaseUrl } from 'components/layout/MambaLayout/CreateContext'
import { LandingIndex } from 'components/page/Landing/LandingIndex'

const Container = styled.section`
  flex-grow: 1;
`

const LandingLayout: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const match = useRouteMatch()
  return (
    <CreateBaseUrl
      uid="geo landing layout"
      contextId={mambaLayoutContextId}
      baseUrl={match?.url!}
      basePath={match?.path!}
    >
      <LandingIndex />
      <Container>{children}</Container>
    </CreateBaseUrl>
  )
}

export default LandingLayout
